export const addPaymentMethodTranslations = {
  en: {
    'addPaymentMethod.paypalDescription': 'Use your existing PayPal account',
    'addPaymentMethod.instantTransfers': 'Instant transfers',
    'addPaymentMethod.paypalBalance': 'PayPal balance',
    'addPaymentMethod.buyerProtection': 'Buyer protection',
    'addPaymentMethod.paypalFee': '3.49% + $0.49',
    'addPaymentMethod.bitcoinTitle': 'Bitcoin Wallet',
    'addPaymentMethod.bitcoinDescription': 'Connect your Bitcoin wallet for payments',
    'addPaymentMethod.decentralized': 'Decentralized payments',
    'addPaymentMethod.global': 'Global accessibility',
    'addPaymentMethod.directWallet': 'Direct wallet connection',
    'addPaymentMethod.networkFees': 'Network fees only',
    'addPaymentMethod.variableSpeed': 'Variable (10-60 min)',
    'addPaymentMethod.success': 'Payment method added successfully',
    'addPaymentMethod.successDescCard': 'Your credit card has been connected.',
    'addPaymentMethod.successDescBank': 'Your bank account has been connected.',
    'addPaymentMethod.successDescPaypal': 'Your PayPal account has been connected.',
    'addPaymentMethod.error': 'Error',
    'addPaymentMethod.errorDesc': 'Failed to add payment method',
    'addPaymentMethod.recommended': 'Recommended',
    'addPaymentMethod.fees': 'Fees',
    'addPaymentMethod.speed': 'Speed',
    'addPaymentMethod.security': 'Security',
    'addPaymentMethod.secure': 'Secure',
    'addPaymentMethod.features': 'Features:',
    'addPaymentMethod.backToSources': 'Back to Payment Sources',
    'addPaymentMethod.step1': 'Step 1 of 2',
    'addPaymentMethod.step2': 'Step 2 of 2',
    'addPaymentMethod.usBankQuestion': 'US Bank?',
    'addPaymentMethod.yes': 'Yes',
    'addPaymentMethod.no': 'No',
  },
  es: {
    'addPaymentMethod.paypalDescription': 'Usa tu cuenta de PayPal existente',
    'addPaymentMethod.instantTransfers': 'Transferencias instantáneas',
    'addPaymentMethod.paypalBalance': 'Saldo de PayPal',
    'addPaymentMethod.buyerProtection': 'Protección al comprador',
    'addPaymentMethod.paypalFee': '3.49% + $0.49',
    'addPaymentMethod.bitcoinTitle': 'Cartera de Bitcoin',
    'addPaymentMethod.bitcoinDescription': 'Conecta tu cartera de Bitcoin para pagos',
    'addPaymentMethod.decentralized': 'Pagos descentralizados',
    'addPaymentMethod.global': 'Accesibilidad global',
    'addPaymentMethod.directWallet': 'Conexión directa con la cartera',
    'addPaymentMethod.networkFees': 'Solo tarifas de red',
    'addPaymentMethod.variableSpeed': 'Variable (10-60 min)',
    'addPaymentMethod.success': 'Método de pago añadido con éxito',
    'addPaymentMethod.successDescCard': 'Tu tarjeta de crédito ha sido conectada.',
    'addPaymentMethod.successDescBank': 'Tu cuenta bancaria ha sido conectada.',
    'addPaymentMethod.successDescPaypal': 'Tu cuenta de PayPal ha sido conectada.',
    'addPaymentMethod.error': 'Error',
    'addPaymentMethod.errorDesc': 'No se pudo añadir el método de pago',
    'addPaymentMethod.recommended': 'Recomendado',
    'addPaymentMethod.fees': 'Comisiones',
    'addPaymentMethod.speed': 'Velocidad',
    'addPaymentMethod.security': 'Seguridad',
    'addPaymentMethod.secure': 'Seguro',
    'addPaymentMethod.features': 'Características:',
    'addPaymentMethod.backToSources': 'Volver a Fuentes de Pago',
    'addPaymentMethod.step1': 'Paso 1 de 2',
    'addPaymentMethod.step2': 'Paso 2 de 2',
    'addPaymentMethod.usBankQuestion': '¿Banco estadounidense?',
    'addPaymentMethod.yes': 'Sí',
    'addPaymentMethod.no': 'No',
  },
  fr: {
    'addPaymentMethod.paypalDescription': 'Utilisez votre compte PayPal existant',
    'addPaymentMethod.instantTransfers': 'Transferts instantanés',
    'addPaymentMethod.paypalBalance': 'Solde PayPal',
    'addPaymentMethod.buyerProtection': 'Protection de l\'acheteur',
    'addPaymentMethod.paypalFee': '3,49% + 0,49 $',
    'addPaymentMethod.bitcoinTitle': 'Portefeuille Bitcoin',
    'addPaymentMethod.bitcoinDescription': 'Connectez votre portefeuille Bitcoin pour les paiements',
    'addPaymentMethod.decentralized': 'Paiements décentralisés',
    'addPaymentMethod.global': 'Accessibilité mondiale',
    'addPaymentMethod.directWallet': 'Connexion directe au portefeuille',
    'addPaymentMethod.networkFees': 'Frais de réseau uniquement',
    'addPaymentMethod.variableSpeed': 'Variable (10-60 min)',
    'addPaymentMethod.success': 'Méthode de paiement ajoutée avec succès',
    'addPaymentMethod.successDescCard': 'Votre carte de crédit a été connectée.',
    'addPaymentMethod.successDescBank': 'Votre compte bancaire a été connecté.',
    'addPaymentMethod.successDescPaypal': 'Votre compte PayPal a été connecté.',
    'addPaymentMethod.error': 'Erreur',
    'addPaymentMethod.errorDesc': 'Échec de l\'ajout de la méthode de paiement',
    'addPaymentMethod.recommended': 'Recommandé',
    'addPaymentMethod.fees': 'Frais',
    'addPaymentMethod.speed': 'Vitesse',
    'addPaymentMethod.security': 'Sécurité',
    'addPaymentMethod.secure': 'Sécurisé',
    'addPaymentMethod.features': 'Caractéristiques :',
    'addPaymentMethod.backToSources': 'Retour aux sources de paiement',
    'addPaymentMethod.step1': 'Étape 1 sur 2',
    'addPaymentMethod.step2': 'Étape 2 sur 2',
    'addPaymentMethod.usBankQuestion': 'Banque américaine ?',
    'addPaymentMethod.yes': 'Oui',
    'addPaymentMethod.no': 'Non',
  },
  sq: {
    'addPaymentMethod.paypalDescription': 'Përdorni llogarinë tuaj ekzistuese të PayPal',
    'addPaymentMethod.instantTransfers': 'Transferta të menjëhershme',
    'addPaymentMethod.paypalBalance': 'Bilanci i PayPal',
    'addPaymentMethod.buyerProtection': 'Mbrojtja e blerësit',
    'addPaymentMethod.paypalFee': '3.49% + $0.49',
    'addPaymentMethod.bitcoinTitle': 'Portofoli Bitcoin',
    'addPaymentMethod.bitcoinDescription': 'Lidhni portofolin tuaj të Bitcoin për pagesa',
    'addPaymentMethod.decentralized': 'Pagesa të decentralizuara',
    'addPaymentMethod.global': 'Aksesueshmëri globale',
    'addPaymentMethod.directWallet': 'Lidhje direkte me portofolin',
    'addPaymentMethod.networkFees': 'Vetëm tarifat e rrjetit',
    'addPaymentMethod.variableSpeed': 'E ndryshueshme (10-60 min)',
    'addPaymentMethod.success': 'Metoda e pagesës u shtua me sukses',
    'addPaymentMethod.successDescCard': 'Karta juaj e kreditit është lidhur.',
    'addPaymentMethod.successDescBank': 'Llogaria juaj bankare është lidhur.',
    'addPaymentMethod.successDescPaypal': 'Llogaria juaj e PayPal është lidhur.',
    'addPaymentMethod.error': 'Gabim',
    'addPaymentMethod.errorDesc': 'Dështoi shtimi i metodës së pagesës',
    'addPaymentMethod.recommended': 'E rekomanduar',
    'addPaymentMethod.fees': 'Tarifat',
    'addPaymentMethod.speed': 'Shpejtësia',
    'addPaymentMethod.security': 'Siguria',
    'addPaymentMethod.secure': 'E sigurt',
    'addPaymentMethod.features': 'Karakteristikat:',
    'addPaymentMethod.backToSources': 'Kthehu te Burimet e Pagesës',
    'addPaymentMethod.step1': 'Hapi 1 nga 2',
    'addPaymentMethod.step2': 'Hapi 2 nga 2',
    'addPaymentMethod.usBankQuestion': 'Banka amerikane?',
    'addPaymentMethod.yes': 'Po',
    'addPaymentMethod.no': 'Jo',
  },
  ru: {
    'addPaymentMethod.paypalDescription': 'Используйте существующий аккаунт PayPal',
    'addPaymentMethod.instantTransfers': 'Мгновенные переводы',
    'addPaymentMethod.paypalBalance': 'Баланс PayPal',
    'addPaymentMethod.buyerProtection': 'Защита покупателя',
    'addPaymentMethod.paypalFee': '3.49% + $0.49',
    'addPaymentMethod.bitcoinTitle': 'Кошелек Bitcoin',
    'addPaymentMethod.bitcoinDescription': 'Подключите кошелек Bitcoin для платежей',
    'addPaymentMethod.decentralized': 'Децентрализованные платежи',
    'addPaymentMethod.global': 'Глобальная доступность',
    'addPaymentMethod.directWallet': 'Прямое подключение кошелька',
    'addPaymentMethod.networkFees': 'Только сетевые комиссии',
    'addPaymentMethod.variableSpeed': 'Переменная (10-60 мин)',
    'addPaymentMethod.success': 'Способ оплаты успешно добавлен',
    'addPaymentMethod.successDescCard': 'Ваша кредитная карта подключена.',
    'addPaymentMethod.successDescBank': 'Ваш банковский счет подключен.',
    'addPaymentMethod.successDescPaypal': 'Ваш аккаунт PayPal подключен.',
    'addPaymentMethod.error': 'Ошибка',
    'addPaymentMethod.errorDesc': 'Не удалось добавить способ оплаты',
    'addPaymentMethod.recommended': 'Рекомендуется',
    'addPaymentMethod.fees': 'Комиссии',
    'addPaymentMethod.speed': 'Скорость',
    'addPaymentMethod.security': 'Безопасность',
    'addPaymentMethod.secure': 'Безопасно',
    'addPaymentMethod.features': 'Особенности:',
    'addPaymentMethod.backToSources': 'Назад к источникам платежей',
    'addPaymentMethod.step1': 'Шаг 1 из 2',
    'addPaymentMethod.step2': 'Шаг 2 из 2',
    'addPaymentMethod.usBankQuestion': 'Американский банк?',
    'addPaymentMethod.yes': 'Да',
    'addPaymentMethod.no': 'Нет',
  },
  pt: {
    'addPaymentMethod.paypalDescription': 'Use sua conta PayPal existente',
    'addPaymentMethod.instantTransfers': 'Transferências instantâneas',
    'addPaymentMethod.paypalBalance': 'Saldo PayPal',
    'addPaymentMethod.buyerProtection': 'Proteção ao comprador',
    'addPaymentMethod.paypalFee': '3.49% + $0.49',
    'addPaymentMethod.bitcoinTitle': 'Carteira Bitcoin',
    'addPaymentMethod.bitcoinDescription': 'Conecte sua carteira Bitcoin para pagamentos',
    'addPaymentMethod.decentralized': 'Pagamentos descentralizados',
    'addPaymentMethod.global': 'Acessibilidade global',
    'addPaymentMethod.directWallet': 'Conexão direta com carteira',
    'addPaymentMethod.networkFees': 'Apenas taxas de rede',
    'addPaymentMethod.variableSpeed': 'Variável (10-60 min)',
    'addPaymentMethod.success': 'Método de pagamento adicionado com sucesso',
    'addPaymentMethod.successDescCard': 'Seu cartão de crédito foi conectado.',
    'addPaymentMethod.successDescBank': 'Sua conta bancária foi conectada.',
    'addPaymentMethod.successDescPaypal': 'Sua conta PayPal foi conectada.',
    'addPaymentMethod.error': 'Erro',
    'addPaymentMethod.errorDesc': 'Falha ao adicionar método de pagamento',
    'addPaymentMethod.recommended': 'Recomendado',
    'addPaymentMethod.fees': 'Taxas',
    'addPaymentMethod.speed': 'Velocidade',
    'addPaymentMethod.security': 'Segurança',
    'addPaymentMethod.secure': 'Seguro',
    'addPaymentMethod.features': 'Recursos:',
    'addPaymentMethod.backToSources': 'Voltar para Fontes de Pagamento',
    'addPaymentMethod.step1': 'Passo 1 de 2',
    'addPaymentMethod.step2': 'Passo 2 de 2',
    'addPaymentMethod.usBankQuestion': 'Banco americano?',
    'addPaymentMethod.yes': 'Sim',
    'addPaymentMethod.no': 'Não',
  },
  el: {
    'addPaymentMethod.paypalDescription': 'Χρησιμοποιήστε τον υπάρχοντα λογαριασμό PayPal σας',
    'addPaymentMethod.instantTransfers': 'Άμεσες μεταφορές',
    'addPaymentMethod.paypalBalance': 'Υπόλοιπο PayPal',
    'addPaymentMethod.buyerProtection': 'Προστασία αγοραστή',
    'addPaymentMethod.paypalFee': '3,49% + $0,49',
    'addPaymentMethod.bitcoinTitle': 'Πορτοφόλι Bitcoin',
    'addPaymentMethod.bitcoinDescription': 'Συνδέστε το πορτοφόλι Bitcoin σας για πληρωμές',
    'addPaymentMethod.decentralized': 'Αποκεντρωμένες πληρωμές',
    'addPaymentMethod.global': 'Παγκόσμια προσβασιμότητα',
    'addPaymentMethod.directWallet': 'Άμεση σύνδεση πορτοφολιού',
    'addPaymentMethod.networkFees': 'Μόνο τέλη δικτύου',
    'addPaymentMethod.variableSpeed': 'Μεταβλητή (10-60 λεπτά)',
    'addPaymentMethod.success': 'Η μέθοδος πληρωμής προστέθηκε με επιτυχία',
    'addPaymentMethod.successDescCard': 'Η πιστωτική σας κάρτα συνδέθηκε.',
    'addPaymentMethod.successDescBank': 'Ο τραπεζικός σας λογαριασμός συνδέθηκε.',
    'addPaymentMethod.successDescPaypal': 'Ο λογαριασμός PayPal σας συνδέθηκε.',
    'addPaymentMethod.error': 'Σφάλμα',
    'addPaymentMethod.errorDesc': 'Αποτυχία προσθήκης μεθόδου πληρωμής',
    'addPaymentMethod.recommended': 'Συνιστάται',
    'addPaymentMethod.fees': 'Τέλη',
    'addPaymentMethod.speed': 'Ταχύτητα',
    'addPaymentMethod.security': 'Ασφάλεια',
    'addPaymentMethod.secure': 'Ασφαλές',
    'addPaymentMethod.features': 'Χαρακτηριστικά:',
    'addPaymentMethod.backToSources': 'Επιστροφή στις Πηγές Πληρωμής',
    'addPaymentMethod.step1': 'Βήμα 1 από 2',
    'addPaymentMethod.step2': 'Βήμα 2 από 2',
    'addPaymentMethod.usBankQuestion': 'Αμερικανική τράπεζα;',
    'addPaymentMethod.yes': 'Ναι',
    'addPaymentMethod.no': 'Όχι',
  },
  de: {
    'addPaymentMethod.paypalDescription': 'Verwenden Sie Ihr bestehendes PayPal-Konto',
    'addPaymentMethod.instantTransfers': 'Sofortige Überweisungen',
    'addPaymentMethod.paypalBalance': 'PayPal-Guthaben',
    'addPaymentMethod.buyerProtection': 'Käuferschutz',
    'addPaymentMethod.paypalFee': '3,49% + 0,49 $',
    'addPaymentMethod.bitcoinTitle': 'Bitcoin-Wallet',
    'addPaymentMethod.bitcoinDescription': 'Verbinden Sie Ihre Bitcoin-Wallet für Zahlungen',
    'addPaymentMethod.decentralized': 'Dezentrale Zahlungen',
    'addPaymentMethod.global': 'Weltweite Verfügbarkeit',
    'addPaymentMethod.directWallet': 'Direkte Wallet-Verbindung',
    'addPaymentMethod.networkFees': 'Nur Netzwerkgebühren',
    'addPaymentMethod.variableSpeed': 'Variabel (10-60 Min)',
    'addPaymentMethod.success': 'Zahlungsmethode erfolgreich hinzugefügt',
    'addPaymentMethod.successDescCard': 'Ihre Kreditkarte wurde verbunden.',
    'addPaymentMethod.successDescBank': 'Ihr Bankkonto wurde verbunden.',
    'addPaymentMethod.successDescPaypal': 'Ihr PayPal-Konto wurde verbunden.',
    'addPaymentMethod.error': 'Fehler',
    'addPaymentMethod.errorDesc': 'Zahlungsmethode konnte nicht hinzugefügt werden',
    'addPaymentMethod.recommended': 'Empfohlen',
    'addPaymentMethod.fees': 'Gebühren',
    'addPaymentMethod.speed': 'Geschwindigkeit',
    'addPaymentMethod.security': 'Sicherheit',
    'addPaymentMethod.secure': 'Sicher',
    'addPaymentMethod.features': 'Funktionen:',
    'addPaymentMethod.backToSources': 'Zurück zu Zahlungsquellen',
    'addPaymentMethod.step1': 'Schritt 1 von 2',
    'addPaymentMethod.step2': 'Schritt 2 von 2',
    'addPaymentMethod.usBankQuestion': 'US-Bank?',
    'addPaymentMethod.yes': 'Ja',
    'addPaymentMethod.no': 'Nein',
  },
  ro: {
    'addPaymentMethod.paypalDescription': 'Folosiți contul dvs. PayPal existent',
    'addPaymentMethod.instantTransfers': 'Transferuri instantanee',
    'addPaymentMethod.paypalBalance': 'Sold PayPal',
    'addPaymentMethod.buyerProtection': 'Protecție cumpărător',
    'addPaymentMethod.paypalFee': '3,49% + $0,49',
    'addPaymentMethod.bitcoinTitle': 'Portofel Bitcoin',
    'addPaymentMethod.bitcoinDescription': 'Conectați portofelul Bitcoin pentru plăți',
    'addPaymentMethod.decentralized': 'Plăți descentralizate',
    'addPaymentMethod.global': 'Accesibilitate globală',
    'addPaymentMethod.directWallet': 'Conexiune directă portofel',
    'addPaymentMethod.networkFees': 'Doar taxe de rețea',
    'addPaymentMethod.variableSpeed': 'Variabil (10-60 min)',
    'addPaymentMethod.success': 'Metodă de plată adăugată cu succes',
    'addPaymentMethod.successDescCard': 'Cardul dvs. de credit a fost conectat.',
    'addPaymentMethod.successDescBank': 'Contul dvs. bancar a fost conectat.',
    'addPaymentMethod.successDescPaypal': 'Contul dvs. PayPal a fost conectat.',
    'addPaymentMethod.error': 'Eroare',
    'addPaymentMethod.errorDesc': 'Nu s-a putut adăuga metoda de plată',
    'addPaymentMethod.recommended': 'Recomandat',
    'addPaymentMethod.fees': 'Taxe',
    'addPaymentMethod.speed': 'Viteză',
    'addPaymentMethod.security': 'Securitate',
    'addPaymentMethod.secure': 'Sigur',
    'addPaymentMethod.features': 'Caracteristici:',
    'addPaymentMethod.backToSources': 'Înapoi la Surse de Plată',
    'addPaymentMethod.step1': 'Pasul 1 din 2',
    'addPaymentMethod.step2': 'Pasul 2 din 2',
    'addPaymentMethod.usBankQuestion': 'Američka banka?',
    'addPaymentMethod.yes': 'Da',
    'addPaymentMethod.no': 'Nu',
  },
  sr: {
    'addPaymentMethod.paypalDescription': 'Користите ваш постојећи ПаиПал налог',
    'addPaymentMethod.instantTransfers': 'Инстант трансфери',
    'addPaymentMethod.paypalBalance': 'ПаиПал салдо',
    'addPaymentMethod.buyerProtection': 'Заштита купца',
    'addPaymentMethod.paypalFee': '3.49% + $0.49',
    'addPaymentMethod.bitcoinTitle': 'Биткоин новчаник',
    'addPaymentMethod.bitcoinDescription': 'Повежите свој Биткоин новчаник за плаћања',
    'addPaymentMethod.decentralized': 'Децентрализована плаћања',
    'addPaymentMethod.global': 'Глобална доступност',
    'addPaymentMethod.directWallet': 'Директна веза са новчаником',
    'addPaymentMethod.networkFees': 'Само мрежне накнаде',
    'addPaymentMethod.variableSpeed': 'Променљиво (10-60 мин)',
    'addPaymentMethod.success': 'Начин плаћања успешно додат',
    'addPaymentMethod.successDescCard': 'Ваша кредитна картица је повезана.',
    'addPaymentMethod.successDescBank': 'Ваш банковни рачун је повезан.',
    'addPaymentMethod.successDescPaypal': 'Ваш ПаиПал налог је повезан.',
    'addPaymentMethod.error': 'Грешка',
    'addPaymentMethod.errorDesc': 'Додавање начина плаћања није успело',
    'addPaymentMethod.recommended': 'Препоручено',
    'addPaymentMethod.fees': 'Накнаде',
    'addPaymentMethod.speed': 'Брзина',
    'addPaymentMethod.security': 'Сигурност',
    'addPaymentMethod.secure': 'Сигурно',
    'addPaymentMethod.features': 'Карактеристике:',
    'addPaymentMethod.backToSources': 'Назад на изворе плаћања',
    'addPaymentMethod.step1': 'Корак 1 од 2',
    'addPaymentMethod.step2': 'Корак 2 од 2',
    'addPaymentMethod.usBankQuestion': 'Америчка банка?',
    'addPaymentMethod.yes': 'Да',
    'addPaymentMethod.no': 'Не',
  },
  pl: {
    'addPaymentMethod.paypalDescription': 'Użyj swojego istniejącego konta PayPal',
    'addPaymentMethod.instantTransfers': 'Natychmiastowe transfery',
    'addPaymentMethod.paypalBalance': 'Saldo PayPal',
    'addPaymentMethod.buyerProtection': 'Ochrona kupującego',
    'addPaymentMethod.paypalFee': '3.49% + $0.49',
    'addPaymentMethod.bitcoinTitle': 'Portfel Bitcoin',
    'addPaymentMethod.bitcoinDescription': 'Połącz swój portfel Bitcoin do płatności',
    'addPaymentMethod.decentralized': 'Płatności zdecentralizowane',
    'addPaymentMethod.global': 'Dostępność globalna',
    'addPaymentMethod.directWallet': 'Bezpośrednie połączenie z portfelem',
    'addPaymentMethod.networkFees': 'Tylko opłaty sieciowe',
    'addPaymentMethod.variableSpeed': 'Zmienne (10-60 min)',
    'addPaymentMethod.success': 'Metoda płatności dodana pomyślnie',
    'addPaymentMethod.successDescCard': 'Twoja karta kredytowa została połączona.',
    'addPaymentMethod.successDescBank': 'Twoje konto bankowe zostało połączone.',
    'addPaymentMethod.successDescPaypal': 'Twoje konto PayPal zostało połączone.',
    'addPaymentMethod.error': 'Błąd',
    'addPaymentMethod.errorDesc': 'Nie udało się dodać metody płatności',
    'addPaymentMethod.recommended': 'Zalecane',
    'addPaymentMethod.fees': 'Opłaty',
    'addPaymentMethod.speed': 'Szybkość',
    'addPaymentMethod.security': 'Bezpieczeństwo',
    'addPaymentMethod.secure': 'Bezpieczne',
    'addPaymentMethod.features': 'Funkcje:',
    'addPaymentMethod.backToSources': 'Powrót do Źródeł Płatności',
    'addPaymentMethod.step1': 'Krok 1 z 2',
    'addPaymentMethod.step2': 'Krok 2 z 2',
    'addPaymentMethod.usBankQuestion': 'Bank amerykański?',
    'addPaymentMethod.yes': 'Tak',
    'addPaymentMethod.no': 'Nie',
  },
};
